import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useSpotifyAuth from "../lib/useSpotifyAuth";

/**
 * /spotify/callback — receives ?code=... from Spotify, exchanges it for an
 * access token via PKCE, then bounces back to wherever the host started.
 */
export default function SpotifyCallback() {
  const auth = useSpotifyAuth();
  const navigate = useNavigate();
  const [err, setErr] = React.useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const error = params.get("error");
    const backTo = localStorage.getItem("tapin_spotify_return") || "/radio/host";
    if (error) { setErr(error); return; }
    if (!code) { navigate(backTo, { replace: true }); return; }
    auth.exchangeCode(code)
      .then(() => {
        localStorage.removeItem("tapin_spotify_return");
        navigate(backTo, { replace: true });
      })
      .catch((e) => setErr(e.message || String(e)));
    // eslint-disable-next-line
  }, []);

  return (
    <div data-testid="spotify-callback" className="min-h-screen bg-[#05060a] text-white flex items-center justify-center p-8">
      <div className="max-w-sm text-center">
        <div className="text-tv-accent font-display font-black text-lg mb-2">Signing you into Spotify…</div>
        {err
          ? <div className="text-red-300 text-sm">Spotify sign-in failed: {err}</div>
          : <div className="text-white/50 text-sm">Redirecting you back to the studio.</div>}
      </div>
    </div>
  );
}
